import { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Users, ChevronDown, ChevronUp } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CoachesPage = () => {
  const [coaches, setCoaches] = useState([]);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    axios.get(`${API}/coaches`).then(res => setCoaches(res.data)).catch(() => {});
  }, []);

  const toggle = (id) => setExpandedId(prev => prev === id ? null : id);

  return (
    <div className="min-h-screen bg-[#FFFBF5]" data-testid="coaches-page">
      <Header />
      
      <main>
        {/* Hero */}
        <section className="bg-gradient-to-br from-[#ff3131] to-[#e62e2e] py-16 text-center text-white">
          <div className="container-gymtots">
            <h1 className="text-4xl sm:text-5xl font-bold mb-3" style={{ fontFamily: 'Fredoka, cursive' }}>
              Our Coaches
            </h1>
            <p className="text-white/80 text-base sm:text-lg max-w-lg mx-auto">
              Meet the team who make every class fun, safe and unforgettable
            </p>
          </div>
        </section>

        <section className="container-gymtots py-12">
          {coaches.length === 0 ? (
            <div className="text-center py-16">
              <Users className="w-16 h-16 text-[#636E72] mx-auto mb-4" />
              <p className="text-[#636E72] text-lg">Coach profiles coming soon!</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {coaches.map(coach => (
                <div key={coach.id} className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-testid={`coach-card-${coach.id}`}>
                  {/* Photo */}
                  {coach.image_url ? (
                    <img
                      src={coach.image_url}
                      alt={coach.full_name}
                      className="w-full h-64 object-cover"
                    />
                  ) : (
                    <div className="w-full h-64 bg-gradient-to-br from-[#7dbff8]/20 to-[#ff3131]/10 flex items-center justify-center">
                      <Users className="w-20 h-20 text-[#7dbff8]/40" />
                    </div>
                  )}

                  {/* Name & Position */}
                  <div className="p-5">
                    <h3 className="text-xl font-bold text-[#2D3436]" style={{ fontFamily: 'Fredoka, cursive' }}>
                      {coach.full_name}
                    </h3>
                    <p className="text-sm text-[#7dbff8] font-semibold mb-3">
                      {coach.position}
                    </p>

                    {/* Expandable Bio */}
                    {(coach.bio || coach.qualifications) && (
                      <div>
                        <button
                          onClick={() => toggle(coach.id)}
                          className="flex items-center gap-1 text-sm text-[#636E72] hover:text-[#ff3131] transition-colors"
                          data-testid={`coach-bio-toggle-${coach.id}`}
                        >
                          {expandedId === coach.id ? (
                            <>Less <ChevronUp className="w-4 h-4" /></>
                          ) : (
                            <>About {coach.full_name.split(" ")[0]} <ChevronDown className="w-4 h-4" /></>
                          )}
                        </button>
                        {expandedId === coach.id && (
                          <div className="mt-2 animate-slide-up" data-testid={`coach-bio-${coach.id}`}>
                            {coach.bio && (
                              <p className="text-sm text-[#636E72] leading-relaxed">{coach.bio}</p>
                            )}
                            {coach.qualifications && (
                              <ul className="mt-2 space-y-1">
                                {coach.qualifications.split(",").map((q, i) => (
                                  <li key={i} className="flex items-start gap-2 text-sm text-[#636E72]">
                                    <span className="w-1.5 h-1.5 rounded-full bg-[#ff3131] mt-1.5 flex-shrink-0" />
                                    {q.trim()}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default CoachesPage;
